module.exports = __webpack_public_path__ + "assets/img/ambition-1.b08e18d7.svg";